import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveZone } from '../../shared/components';

export type CreateZonePageProps = {};

const CreateZonePage: React.FC<CreateZonePageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_zona);

  return <SaveZone titlePage="Crear Zona" />;
};

export default CreateZonePage;
